import { initialState } from '../initial';
import { actionTypes } from '../actions';

export function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ACTION_PROCESSING:
      return { ...state, actionProcessing: action.payload };

    case actionTypes.GET_CURRENT_GIFTS:
      return { ...state, currentGifts: action.payload };

    case actionTypes.CURRENT_GIFTS_UPDATE_TRIGGER:
      return { ...state, currentGiftsUpdateTrigger: {} };

    case actionTypes.GET_GIFT_REQUESTS:
      return { ...state, giftRequests: action.payload };

    case actionTypes.GET_CHRISTMAS_TOURNAMENT:
      return { ...state, christmasTournament: action.payload };

    case actionTypes.GET_JACKTOP_TOURNAMENT:
      return { ...state, jacktopTournament: action.payload };

    case actionTypes.GET_RUBYPLAY_TOURNAMENT:
      return { ...state, rubyPlayTournament: action.payload };

    case actionTypes.GET_NETENT_TOURNAMENT:
      return { ...state, netentTournament: action.payload };

    case actionTypes.GET_PROMOTIONS:
      return { ...state, promotions: action.payload };

    case actionTypes.GET_PROMOTION_BY_ID:
      return { ...state, promotions: { ...state.promotions, promotionById: action.payload } };

    default:
      return state;
  }
}
